import React, { useState } from 'react';
import { Card, Badge, Table, Button, Form, InputGroup } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

const StockListView = ({ watchlist, stocks, prices, onRemoveStock, onAddStock, tickerSymbol, onTickerSymbolChange, children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const normalizedStocks = (stocks || [])
    .map(item => {
      const stock = item?.stock || item;
      if (!stock?.ticker_symbol) return null;
      return { stock };
    })
    .filter(Boolean);
  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <h6 className="mb-0 me-2">{watchlist.name}</h6>
          <Badge bg="secondary">
            {normalizedStocks.length} stocks
          </Badge>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => setCollapsed(prev => !prev)}
          >
            {collapsed ? 'Expand' : 'Minimize'}
          </Button>
          {children}
        </div>
      </Card.Header>
      {!collapsed && (
        <Card.Body style={{ padding: '0' }}>
        {normalizedStocks.length > 0 ? (
          <Table striped hover size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>Name</th>
                <th>Price</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {normalizedStocks.map(({ stock }) => (
                <tr key={stock.id || `${watchlist.id}-${stock.ticker_symbol}`}>
                  <td>
                    <Link to={`/stock/${stock.ticker_symbol}`} target="_blank" rel="noopener noreferrer">
                      <strong>{stock.ticker_symbol}</strong>
                    </Link>
                  </td>
                  <td>
                    <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {stock.company_name || '-'}
                    </div>
                  </td>
                  <td>
                    <span className={
                      prices[stock.ticker_symbol]?.change < 0 ? 'text-danger' :
                      prices[stock.ticker_symbol]?.change > 0 ? 'text-success' : 'text-muted'
                    }>
                      ${prices[stock.ticker_symbol]?.price?.toFixed(2) || '--'}
                    </span>
                  </td>
                  <td>
                    <span className={
                      prices[stock.ticker_symbol]?.change > 0 ? 'text-success' : 
                      prices[stock.ticker_symbol]?.change < 0 ? 'text-danger' : 'text-muted'
                    }>
                      {prices[stock.ticker_symbol]?.change?.toFixed(2) || '--'}
                    </span>
                  </td>
                  <td>
                    <span className={
                      prices[stock.ticker_symbol]?.changePercentage > 0 ? 'text-success' : 
                      prices[stock.ticker_symbol]?.changePercentage < 0 ? 'text-danger' : 'text-muted'
                    }>
                      {prices[stock.ticker_symbol]?.changePercentage 
                        ? prices[stock.ticker_symbol].changePercentage.toFixed(2) + '%' 
                        : '--%'}
                    </span>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => onRemoveStock(watchlist.id, stock.id)}
                      disabled={!stock.id}
                      title="Remove from watchlist"
                    >
                      <Trash size={12} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="text-center text-muted py-4">
            <p>No stocks in this watchlist</p>
          </div>
        )}
        </Card.Body>
      )}
      {!collapsed && (
        <Card.Footer>
          <Form onSubmit={(e) => onAddStock(e, watchlist.id)}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Add ticker..."
                value={tickerSymbol}
                onChange={onTickerSymbolChange}
              />
              <Button variant="outline-secondary" type="submit">Add</Button>
            </InputGroup>
          </Form>
        </Card.Footer>
      )}
    </Card>
  );
};

export default StockListView;
